type AttachmentDropError = {
  key:
    | 'viewModel.aiChat.imageCountLimit'
    | 'viewModel.aiChat.fileCountLimit'
    | 'viewModel.aiChat.attachmentTotalLimit'
    | 'viewModel.aiChat.fileSizeLimit';
  params: { max: number };
};

type AttachmentDropInput = {
  currentImageCount: number;
  currentFileCount: number;
  newImageCount: number;
  newFileSizes: number[];
  limits: { imageMax: number; fileMax: number; totalMax: number; fileByteLimit: number };
};

/**
 * 1回のドロップ全体を all-or-nothing で検証する。
 * 画像・ファイルの個数、合計個数、ファイルサイズのいずれかが上限に触れたら、最初のエラーを返す。
 * 種別をまたいで全件中止することで、片方だけ添付される中途半端な結果を防ぐ。
 */
export function validateAttachmentDrop(input: AttachmentDropInput): AttachmentDropError | null {
  const { currentImageCount, currentFileCount, newImageCount, newFileSizes, limits } = input;
  const newFileCount = newFileSizes.length;

  if (currentImageCount + newImageCount > limits.imageMax) {
    return { key: 'viewModel.aiChat.imageCountLimit', params: { max: limits.imageMax } };
  }
  if (currentFileCount + newFileCount > limits.fileMax) {
    return { key: 'viewModel.aiChat.fileCountLimit', params: { max: limits.fileMax } };
  }
  if (currentImageCount + newImageCount + currentFileCount + newFileCount > limits.totalMax) {
    return { key: 'viewModel.aiChat.attachmentTotalLimit', params: { max: limits.totalMax } };
  }
  if (newFileSizes.some((size) => size >= limits.fileByteLimit)) {
    return { key: 'viewModel.aiChat.fileSizeLimit', params: { max: limits.fileByteLimit / (1024 * 1024) } };
  }
  return null;
}
